export default __webpack_public_path__ + "static/media/banner.771bb81e.jpg";